import React from 'react'
// components
import { ReduxSelect } from 'components/FormElements'
// types
import { FieldType, IField } from 'types/graphql'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'

interface Props {
  property: IField
}

const SectionSelect: React.FC<Props> = ({ property }) => {
  const { basicFields } = React.useContext(RiskTemplateAPIContext)

  const isTableParent = property?.parentFieldId
    ? !!basicFields.find((f) => f.id === property.parentFieldId && f.fieldType === FieldType.Table)
    : false

  if (isTableParent) {
    return null
  }

  const sections = basicFields
    .filter((field) => field.fieldType === FieldType.Section && field.id !== property.id)
    .map((field) => ({
      label: field.label,
      value: field.id
    }))

  return <ReduxSelect name={'parentFieldId'} label={'Section'} options={sections} isClearable />
}

export default SectionSelect
